import { DataTable } from "@/components/admin/data-table";
import { DateField } from "@/components/admin/date-field";
import { ExportButton } from "@/components/admin/export-button";
import { FilterButton } from "@/components/admin/filter-form";
import { List } from "@/components/admin/list";
import { SearchInput } from "@/components/admin/search-input";
import { SelectInput } from "@/components/admin/select-input";
import { Badge } from "@/components/ui/badge";

import { TopToolbar } from "../layout/TopToolbar";
import type { Subscriber } from "../types";
import {
  subscriberStatusBadgeVariant,
  subscriberStatusLabel,
} from "./subscriberUtils";

const statusChoices = [
  { id: "subscribed", name: "Subscribed" },
  { id: "welcome_sent", name: "Welcomed" },
  { id: "welcome_failed", name: "Welcome failed" },
  { id: "bounced", name: "Bounced" },
  { id: "complained", name: "Complained" },
  { id: "unsubscribed", name: "Unsubscribed" },
];

const subscriberFilters = [
  <SearchInput source="q" alwaysOn />,
  <SelectInput
    source="status"
    label="Status"
    emptyText="Any status"
    choices={statusChoices}
    optionText="name"
    optionValue="id"
  />,
];

export const SubscriberList = () => {
  return (
    <List
      title="Mail List"
      perPage={25}
      sort={{ field: "created_at", order: "DESC" }}
      filters={subscriberFilters}
      actions={<SubscriberListActions />}
    >
      <DataTable<Subscriber> bulkActionButtons={false}>
        <DataTable.Col source="email" label="Email" />
        <DataTable.Col
          source="status"
          label="Status"
          render={(record) => (
            <Badge variant={subscriberStatusBadgeVariant(record.status)}>
              {subscriberStatusLabel(record.status)}
            </Badge>
          )}
        />
        <DataTable.Col source="source" label="Source" />
        <DataTable.Col source="locale" label="Locale" />
        <DataTable.Col source="created_at" label="Signed up">
          <DateField source="created_at" showTime />
        </DataTable.Col>
      </DataTable>
    </List>
  );
};

const SubscriberListActions = () => (
  <TopToolbar>
    <FilterButton />
    <ExportButton />
  </TopToolbar>
);
